export function inventoryAccount(inventory) {
  const cloud = inventory.proveedor?.toUpperCase();
  if (!['AWS', 'GCP'].includes(cloud)) return '';
  const id = inventory.numero_cliente;
  const legacy = inventory.nombre_cliente_legacy;
  if (cloud === 'GCP') return id ? `Proyecto GCP: ${id}` : '';
  const alias = id && (legacy?.endsWith(`_${id}`) || legacy?.endsWith(`-${id}`))
    ? legacy.slice(0, -id.length - 1) : legacy;
  return `Cuenta AWS: ${alias || id || 'No informada'}${alias && id && alias !== id ? ` · ${id}` : ''}`;
}
